var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mobile alumni-directory-div" }, [
    _c(
      "div",
      { staticClass: "search" },
      [
        _c("van-search", {
          attrs: { shape: "round", placeholder: "搜索" },
          on: { input: _vm.search },
          model: {
            value: _vm.keywords,
            callback: function ($$v) {
              _vm.keywords = $$v
            },
            expression: "keywords",
          },
        }),
      ],
      1
    ),
    _vm.dataList.length > 0
      ? _c(
          "div",
          { staticClass: "alumni-directory-main" },
          _vm._l(_vm.dataList, function (item, index) {
            return _c(
              "div",
              {
                key: "alumnidirectorylist" + index,
                staticClass: "alumni-directory-list",
              },
              [
                item.isTeacher == 1
                  ? _c(
                      "div",
                      { staticClass: "alumni-directory-list-head-teacher" },
                      [_vm._v(" " + _vm._s(item.title || "") + " ")]
                    )
                  : _c(
                      "div",
                      { staticClass: "alumni-directory-list-head-group" },
                      [_vm._v(_vm._s(item.title || ""))]
                    ),
                _c(
                  "div",
                  { staticClass: "alumni-directory-list-content" },
                  [
                    _vm._l(item.alumniBooks, function (tempInfo, tempIndex) {
                      return _c(
                        "div",
                        {
                          key: "alumnidirectorylistitem" + tempIndex,
                          staticClass: "alumni-directory-list-item",
                          class:
                            (item.alumniBooks.length % 2 > 0 &&
                              tempIndex >= item.alumniBooks.length - 1) ||
                            (item.alumniBooks.length % 2 == 0 &&
                              tempIndex >= item.alumniBooks.length - 2)
                              ? "last-item"
                              : "normal-item",
                        },
                        [
                          _c("van-image", {
                            class:
                              tempIndex % 2 > 0
                                ? "item-image-right"
                                : "item-image-left",
                            attrs: {
                              "lazy-load": "",
                              src: _vm._f("imgFormat")(tempInfo.photo),
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "loading",
                                  fn: function () {
                                    return [
                                      _c("van-loading", {
                                        attrs: { type: "spinner", size: "20" },
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "error",
                                  fn: function () {
                                    return [
                                      _c("img", {
                                        staticStyle: {
                                          width: "100%",
                                          height: "100%",
                                        },
                                        attrs: {
                                          src: _vm._f("imgFormat")(
                                            _vm.defaultImg
                                          ),
                                        },
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                          _c("div", { staticClass: "item-infocontent" }, [
                            _c(
                              "div",
                              { staticClass: "item-name van-ellipsis" },
                              [_vm._v(_vm._s(tempInfo.name || ""))]
                            ),
                            _c(
                              "div",
                              { staticClass: "item-phone van-ellipsis" },
                              [_vm._v(_vm._s(tempInfo.phone || ""))]
                            ),
                            _c(
                              "div",
                              { staticClass: "item-detail van-ellipsis" },
                              [_vm._v(_vm._s(tempInfo.job || ""))]
                            ),
                          ]),
                        ],
                        1
                      )
                    }),
                    _c("div", { staticClass: "alumni-directory-list-line" }),
                  ],
                  2
                ),
              ]
            )
          }),
          0
        )
      : _c(
          "div",
          { staticClass: "alumni-directory-main" },
          [_c("van-empty", { attrs: { description: "暂无数据" } })],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }